import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

interface IFavoriteMutationVariables {
  saleId: string;
  userId: string;
}

const ADD_FAVORITE: DocumentNode = gql`
  mutation AddFavorite($saleId: String!, $userId: String!) {
    addFavorite(saleId: $saleId, userId: $userId) {
      success
      message
    }
  }
`;

const REMOVE_FAVORITE: DocumentNode = gql`
  mutation RemoveFavorite($saleId: String!, $userId: String!) {
    removeFavorite(saleId: $saleId, userId: $userId) {
      success
      message
    }
  }
`;

export { ADD_FAVORITE, REMOVE_FAVORITE, IFavoriteMutationVariables };
